import RestService from './RestService';

const fetchPaymentIdClick = async (data) => {
  try {
    const response = await RestService.post('/api/clickPayment/getSession', data);
    return { status: response.status.code, result: response.entity };
  } catch (error) {
    return { status: error.status.code, message: error.status.text };
  }
};
const validateClickPayment = async (sessionId) => {
  try {
    const response = await RestService.get(`/api/clickPayment/queryResult?sessionId=${sessionId}`);
    return { status: response.status.code, result: response.entity };
  } catch (error) {
    return { status: error.status.code, message: error.status.text };
  }
};
const ClickPaymentService = {
  fetchPaymentIdClick,
  validateClickPayment
};

export default ClickPaymentService;



/** WEBPACK FOOTER **
 ** ./src/services/ClickPaymentService.js
 **/